import { FC, useContext, useRef, useState } from 'react';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-pro';
import { DataGridTable, ListContext, CombinedTableModel } from '../../../ui';
import { PatientQuestionnaireDataModel } from '../../../patient/network/questionnaires';
import { TRowClickFunction } from '../../../ui/components/DataGridPro/helpers';
import {
  formatNullValues,
  formatDate,
} from '../../../ui/components/DataGridPro/helpers';
import { ScanStatusCellRenderer } from '../../../scan';
import { DataGridResendIcon } from '../../../ui/components/DataGridResendIcon';

export interface PatientQuestionnairesDataGridProps {
  height: string;
}

export const PatientQuestionnairesDataGrid: FC<
  PatientQuestionnairesDataGridProps
> = (props) => {
  const { height } = props;
  const { data, loading } = useContext(ListContext);
  const [selectedRowID, setSelectedRowID] = useState<number | null>(null);
  const buttonHoverRef = useRef(false);

  const handleMouseOver = () => {
    buttonHoverRef.current = true;
  };

  const handleMouseOut = () => {
    buttonHoverRef.current = false;
  };

  const onRowClick: TRowClickFunction<any> = (
    item: GridRowParams<PatientQuestionnaireDataModel>
  ) => {
    setSelectedRowID(Number(item.id));
  };

  const columns: GridColDef<CombinedTableModel>[] = [
    {
      field: 'questionnaire_name',
      headerName: 'Questionnaire',
      flex: 1,
      valueGetter: (params) => {
        return formatNullValues(params.value);
      },
    },
    {
      field: 'questionnaire_status',
      headerName: 'Status',
      flex: 1,
      renderCell: ScanStatusCellRenderer,
    },
    {
      field: 'reminder_date',
      headerName: 'Scheduled Date',
      flex: 1,
      valueGetter: (params) => {
        return formatDate(params.value);
      },
    },
    {
      field: 'completion_date',
      headerName: 'Completion Date',
      flex: 1,
      valueGetter: (params) => {
        return formatDate(params.value);
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      renderCell: (params) => {
        const row = params.row as PatientQuestionnaireDataModel;
        const status = row.questionnaire_status?.toLowerCase();

        // Only show the Send Reminder button for incomplete questionnaires
        if (status === 'incomplete') {
          return (
            <DataGridResendIcon
              label=''
              record={null}
              patientQuestionnaire={row}
              source='questionnaire_status'
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
              selectedRowID={selectedRowID}
              resendtype='questionnaire'
              hide={row?.questionnaire_status !== 'incomplete'}
            />
          );
        }

        return <div></div>;
      },
    },
  ];
  return (
    <DataGridTable
      height={height}
      loading={loading}
      data={data}
      columns={columns}
      tableType='record'
      onRowClick={onRowClick}
      disableSearch={true}
    />
  );
};
